module.exports = __webpack_public_path__ + "static/4-7cebe09e0e24de6e54ab7c271b50bc31.woff";